import { customUrlEventDispatcher } from 'components/common/ocs-custom-events/urlEvents'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly'
import { useMemo } from 'react'

const FireOnContentLoadOCS = ({ data, params, payloadParams, type = 'person' }) => {
    const { mirs_noc } = useUrlFriendlyToParameters()
    let disciplines
    let noc

    switch (type) {
        case 'person':
            disciplines = data?.person?.disciplines?.map(d => d?.code) || []
            noc = data?.person?.organisation?.code
            break
        case 'horse':
            disciplines = data?.horse?.discipline?.code ? [data?.horse?.discipline?.code] : []
            noc = data?.horse?.organisation?.code
            break
        case 'team':
            disciplines = data?.team?.discipline?.code ? [data?.team?.discipline?.code] : []
            noc = data?.team?.organisation?.code
            break
        case 'byNoc':
            disciplines = []
            noc = mirs_noc
        default:
    }

    return useMemo(() => {
        customUrlEventDispatcher({ params: params, payloadParams: payloadParams, disciplines: disciplines, noc: noc })
    }, []);
}

export default FireOnContentLoadOCS